import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import './styles/base.css'
import './styles/auth.css'
import './styles/navigation.css'
import './styles/home.css'
import './styles/platform-polish.css'
import './styles/player-community.css'

Vue.config.productionTip = false

new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js